import { styled } from '@mui/material/styles'
import FormLabel from '@mui/material/FormLabel'

const FormInputLabel = styled(FormLabel, {
    shouldForwardProp: (prop) => prop !== 'sx',
})(({ theme }) => ({
    fontWeight: 600,
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
}))

export default FormInputLabel
